export const functions = {
  SUPERVISOR: 4,
  PROGRAMMER: 5,
  MANAGER: 6,
  INSTRUCTOR: 7,
  NURSE: 8,
  LIFEGUARD: 9,
  CATERING: 10,
  SOCIAL: 11,
  INSTRUCTORASSIST: 12,
  PHOTOGRAPHER: 13,
  COORDINATOR: 14,
  INSTRUCTOR_ZS: 15,
  MANAGERASSIST: 16,
  PHOTOGRAPHER_ZS: 17,
  LIFEGUARD_ZS: 18
};

export const SUPERVISOR = 4;
export const PROGRAMMER = 5;
export const MANAGER = 6;
export const INSTRUCTOR = 7;
export const NURSE = 8;
export const LIFEGUARD = 9;
export const CATERING = 10;
export const SOCIAL = 11;
export const INSTRUCTORASSIST = 12;
export const PHOTOGRAPHER = 13;
export const COORDINATOR = 14;
export const INSTRUCTOR_ZS = 15;
export const MANAGERASSIST = 16;
export const PHOTOGRAPHER_ZS = 17;
export const LIFEGUARD_ZS = 18;
